import { getEscapeKeys } from "./gatewayEscapeKeys";

interface ValidateGatewayProps {
  type?: string;
  formValues: any;
  credentialsType: string;
  selectedCredential: string;
  clientGatewayType: string;

  filterError: any;
  hasEmptyValuesInClient_additional_fees: boolean;
  isValidateVelocity: boolean;
  isValidateAdditionalFees: boolean;
  isValidateAdditionalFeesPricing: boolean;

  checkWallets: () => boolean;
  validateCinetCardTypes: () => boolean;
  validateCinetAdditionalFees: () => boolean;
  validateVelocityEntries: () => boolean;

  setCredentialError: (value: string) => void;
  setFormValuesErr: any;
}

export const validateGateway = ({
  type,
  formValues,
  credentialsType,
  selectedCredential,
  clientGatewayType,

  filterError,
  hasEmptyValuesInClient_additional_fees,
  isValidateVelocity,
  isValidateAdditionalFees,
  isValidateAdditionalFeesPricing,

  checkWallets,
  validateCinetCardTypes,
  validateCinetAdditionalFees,
  validateVelocityEntries,

  setCredentialError,
  setFormValuesErr,
}: ValidateGatewayProps) => {
  const values = formValues ?? {};

  const isLive = values?.is_live ?? false;
  const escape_arr = getEscapeKeys(type ?? "", !isLive);

  // Predefined credential validation
  if (credentialsType === "predefined") {
    if (!selectedCredential) {
      setCredentialError("Please Select Predefined Credentials");
      return false;
    }
    setCredentialError("");
  }

  const verifier: any = {};

  Object.keys(values).forEach((key) => {

    if (credentialsType === "predefined") {
      if (
        key.endsWith("_live") ||
        key.endsWith("_test") ||
        key === "predefinedCredentials"
      ) {
        return;
      }
    }
    
    if (escape_arr.includes(key)) return;

    const value = values[key];

    // Ignore booleans
    if (typeof value === "boolean") return;

    // Ignore objects/arrays (they have their own validators)
    if (Array.isArray(value)) return;
    if (
      value &&
      typeof value === "object" &&
      key !== "crypto_fees"
    ) {
      return;
    }

    if (
      value === "" ||
      value === null ||
      value === undefined
    ) {
      verifier[key] = "Please enter a value";
    }
  });

  console.log("verifier",verifier)
  setFormValuesErr(verifier);

  
  const hasCardTypeErrors = validateCinetCardTypes();
  console.log("card type validation:", hasCardTypeErrors);

  const hasAdditionalFeeErrors = validateCinetAdditionalFees();
  console.log("additional fee validation:", hasAdditionalFeeErrors);
  const hasVelocityErrors = validateVelocityEntries();
  console.log("velocity validation:", hasVelocityErrors);

  if (hasCardTypeErrors) return false;
  if (hasAdditionalFeeErrors) return false;
  if (hasVelocityErrors) return false;

  if (Object.keys(verifier).length > 0) return false;

  if (!checkWallets()) return false;

  if (clientGatewayType === "crypto") {
    if (values.crypto_fees?.percentage_fee === "") {
      setFormValuesErr((prev: any) => ({
        ...prev,
        crypto_fees: {
          ...prev?.crypto_fees,
          percentage_fee: "Please enter a value",
        },
      }));
      return false;
    }

    if (values.crypto_fees?.fixed_fee === "") {
      setFormValuesErr((prev: any) => ({
        ...prev,
        crypto_fees: {
          ...prev?.crypto_fees,
          fixed_fee: "Please enter a value",
        },
      }));
      return false;
    }

    if (values.crypto_fees?.currency_code === "") {
      setFormValuesErr((prev: any) => ({
        ...prev,
        crypto_fees: {
          ...prev?.crypto_fees,
          currency_code: "Please enter a value",
        },
      }));
      return false;
    }
  }

  return true;
};